export default {
    api: {
        action: {
            url: process.env.VUE_APP_API_URL_ACTION,
        },
        mockTestApi: {
            url: 'http://localhost:123',
        },
        backend: {
            url: process.env.VUE_APP_API_URL_BACKEND,
        },
    },
    sentry: process.env.VUE_APP_SENTRY === 'true' ? {
        dsn: process.env.VUE_APP_SENTRY_DSN,
        tracesSampleRate: 0.01,
    } : false,
    gtm: process.env.VUE_APP_GTM === 'true' ? {
        id: 'GTM-5WGVNH5',
        debug: process.env.VUE_APP_GTM_DEBUG === 'true',
    } : false,
    xOriginHeader: process.env.VUE_APP_X_ORIGIN,
    store: {
        strict: process.env.VUE_APP_STORE_STRICT === 'true',
    },
};
